(function () {
    'use strict';

    angular.module('Directives').directive('bbaCompaniesOffices', bbaCompaniesOffices);

    bbaCompaniesOffices.$inject = [
        'CompaniesTableService',
        '$timeout'
    ];

    function bbaCompaniesOffices(
        CompaniesTableService,
        $timeout
    ) {
        return {
            restrict: 'E',
            require: ['^form', '^ngModel'],
            templateUrl: '/templates/directives/components/margins/bba-companies-offices.html',
            scope: {
                ngModel: '=',
                isViewMode: '=?'
            },
            link: bbaCompaniesOfficesLink
        }


        function bbaCompaniesOfficesLink($scope, element, attr, ngModels) {
            $scope.companiesTableService = new CompaniesTableService($scope.ngModel, ngModels[0], { selected: true });
            $scope.companiesData = $scope.companiesTableService.tableData;
            let listener = $scope.$on('companiesTableUpdated', function (data) {
                $timeout(function () {
                    $scope.ngModel.companiesRaw = $scope.companiesTableService.tableData.data.map(val => {
                        return {
                            id: val.id ? val.id : val.company.value.id,
                            offices: val.offices.value.length === 0 ? [] : val.offices.value.map(office => {
                                return office.id;
                            })
                        }
                    });
                });
            });
            $scope.$on('$destroy', function () {
                listener();
            });
        }
    }
})()


// WEBPACK FOOTER //
// ./js/directives/component/margins/bbaCompaniesAndOffices.js